import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes, StatTypes } from '../constants/CentricConstants';

import AssignmentApi from '../server/AssignmentApi.js';

function createSuccessHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}

const _handleFormError = createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR);
const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);

export default {

    getAll: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.ASSIGNMENT_LIST);
        const handleError = createErrorHandler(ActionTypes.ASSIGNMENT_LIST_ERROR);

        return AssignmentApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    getById: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.ASSIGNMENT_INFO);
        const handleError = createErrorHandler(ActionTypes.ASSIGNMENT_INFO_ERROR);

        return AssignmentApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    save: function(entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.ASSIGNMENT_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.ASSIGNMENT_INFO_ERROR, ActionTypes.FORM_SUBMIT_ERROR);
        
        return AssignmentApi.save(entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },

    update: function(id, entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.ASSIGNMENT_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.ASSIGNMENT_UPDATE_ERROR, ActionTypes.FORM_SUBMIT_ERROR);
        
        return AssignmentApi.update(id, entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },
    
    delete: (id) => {
        const types = {
            success: ActionTypes.ASSIGNMENT_DELETE,
            failure: ActionTypes.ASSIGNMENT_DELETE_ERROR
        };

        return CentricDispatcher.dispatchAsync(AssignmentApi.delete(id), types, {id});
    },
  
    search: (searchText, params) => {
        const types = {
            request: ActionTypes.SEARCH_REQUEST,
            success: [ActionTypes.SEARCH_SUCCESS, ActionTypes.ASSIGNMENT_LIST],
            failure: ActionTypes.SEARCH_FAILURE
        };
        CentricDispatcher.dispatchAsync(AssignmentApi.search(searchText, params), types, {searchText, params});
    },
    
    run: function(id) {
        const types = {
            request:    ActionTypes.ASSIGNMENT_RUN_REQUEST,
            success:    [ActionTypes.ASSIGNMENT_RUN_SUCCESS,  ActionTypes.FORM_SUBMIT_SUCCESS],
            failure:    [ActionTypes.ASSIGNMENT_RUN_FAILURE, ActionTypes.FORM_SUBMIT_ERROR]
        };

        return CentricDispatcher.dispatchAsync(AssignmentApi.run(id), types, { id });
    },

    getCount: () => {
        const types = {
            request:    ActionTypes.STATS_INFO_REQUEST,
            success:    ActionTypes.STATS_INFO_SUCCESS,
            failure:    ActionTypes.STATS_INFO_FAILURE
        };

        return CentricDispatcher.dispatchAsync(AssignmentApi.getCount(), types, { key: StatTypes.ASSIGNMENT_COUNT } );
    }
    
};
